import { useEffect } from 'react'

const BlipChat = () => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window === 'undefined') return
    const script = document.createElement('script')
    script.async = true
    script.innerText = `(function () {
      new BlipChat()
        .withAppKey('Z2F6aW5jcmVkYXRlbmRpbWVudG86NzE5YmU3OWUtMjUwZS00YzYyLTkxZTctMjQ0MzBlZjNmMjFk')
        .withButton({ color: '#3D9DEF', icon: '' })
        .withCustomCommonUrl('https://chat.blip.ai/')
        .build()
    })()`

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return null
}

export default BlipChat
